const types = ['hybrid', 'electric', 'energi'];

/**
 * Returns the Dealer Connection specified technology value given a model.
 *
 * @param {string} model The vehicle model
 * @returns {string} The technology value
 */
export default (model) =>
	types.find((type) => model?.toLowerCase()?.includes?.(type)) || 'standard';
